<template>
    <div>
        <div>
            <Header />
            <div>
                <div class="title">
                    <div class="navTitle">
                        <WorkflowBreadcrumb :exhibitName="exhibitName" current="intermediate" />
                        <span class="info-icon">
                            <q-btn flat round dense icon="info">
                                <q-popup-proxy ref="popup">
                                    <q-card>
                                        <q-card-section>
                                            Vos points permettent d'accèder à des pages intermédiaires.
                                            Elles seront les supports explicatifs des objets que vous
                                            allez
                                            exposer et valoriser dans votre exposition virtuelle. Importer les ressources
                                            nécessaires a créer chacune de vos pages intermédiaires et choissisez une
                                            transition
                                            pour les
                                            faire apparaitre. </q-card-section>
                                    </q-card>
                                </q-popup-proxy>
                            </q-btn>
                        </span>
                    </div>

                </div>

                <div class="navButtons">
                    <q-btn color="pink-10" style="margin-left: 7%" @click="navigateBack">Retour</q-btn>
                    <div>
                        <q-btn label="Prévisualiser l'exposition en ligne" color="blue-grey-4" @click="openNewTab" />
                    </div>
                    <div style="margin-right: 7%">
                        <q-btn color="deep-purple-4" label="Page suivante" :disabled="!pointSelected"
                            @click="navigateToAssociation">
                            <q-tooltip>
                                Le passage à la page suivante valide l'ensemble de vos modifications
                            </q-tooltip></q-btn>
                    </div>
                </div>

            </div>
            <hr style="margin-bottom: 15px" />
        </div>
        
        <div class="container">
            <q-dialog v-model="openAssociation">
                <q-card style="width: 700px; max-width: 80vw;">
                    <PointResourceAssociation @closePointResourceAssociation="openAssociation = false" />
                </q-card>
            </q-dialog>
            <q-dialog :maximized="true" transition-show="slide-up" transition-hide="slide-down" v-model="openPlace">
                <Intermediate @closeIntermediate="closeIntermediate" />
            </q-dialog>
            
            <div class="column flex-column" v-if="column1">
                <h4><q-icon name="cloud_upload" /> Importer des fichiers pour la création des pages intermédiaires</h4>
                <div
                    class="drop-zone"
                    :class="{ 'drop-zone--active': isDragging }"
                    @dragover.prevent="isDragging = true"
                    @dragenter.prevent="isDragging = true"
                    @dragleave.prevent="isDragging = false"
                    @drop.prevent="onDrop"
                >
                    <q-icon name="cloud_upload" size="48px" :color="isDragging ? 'primary' : 'grey-6'" />
                    <p class="q-mt-sm q-mb-xs" style="font-size: 14px;">
                        Glissez-déposez vos fichiers ici
                    </p>
                    <p class="text-caption text-grey-6 q-mb-sm">
                        (Images, Vidéos, Audios, Documents Word)
                    </p>
                    <q-file
                        v-model="selectedFiles"
                        label="ou cliquez pour sélectionner"
                        outlined
                        dense
                        multiple
                        accept="image/*,video/*,audio/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        @update:model-value="onFilesSelected"
                        style="max-width: 300px;"
                    >
                        <template v-slot:prepend>
                            <q-icon name="attach_file" />
                        </template>
                    </q-file>
                </div>

                <!-- Liste des fichiers sélectionnés -->
                <div v-if="filesToUpload.length > 0" class="q-mt-md">
                    <div class="text-subtitle2 q-mb-sm">{{ filesToUpload.length }} fichier(s) sélectionné(s)</div>
                    <q-list bordered separator class="rounded-borders q-mb-md">
                        <q-item v-for="(f, idx) in filesToUpload" :key="idx" class="q-pa-sm">
                            <q-item-section>
                                <div class="row items-center q-mb-xs">
                                    <q-icon :name="getFileIcon(f.file.name)" class="q-mr-sm" />
                                    <span class="text-weight-medium">{{ f.file.name }}</span>
                                    <q-space />
                                    <q-icon name="close" class="cursor-pointer" color="negative"
                                        @click="filesToUpload.splice(idx, 1)" />
                                </div>
                                <div class="row q-col-gutter-sm">
                                    <div class="col-6">
                                        <q-input v-model="f.title" label="Titre" dense outlined />
                                    </div>
                                    <div class="col-6">
                                        <q-input v-model="f.source" label="Nom de la source" dense outlined />
                                    </div>
                                    <div class="col-6">
                                        <q-input v-model="f.description" label="Description" dense outlined
                                            type="textarea" autogrow />
                                    </div>
                                    <div class="col-6">
                                        <q-input v-model="f.source_url" label="URL de la source" dense outlined />
                                    </div>
                                </div>
                            </q-item-section>
                        </q-item>
                    </q-list>
                    <q-btn @click="importFiles" color="secondary" label="Importer tous les fichiers" :loading="uploading" />
                </div>

                <!-- Progression -->
                <div v-if="uploading" class="q-mt-md">
                    <div class="text-caption q-mb-xs">
                        Fichier {{ uploadCurrent }} / {{ uploadTotal }}
                    </div>
                    <q-linear-progress :value="progress / 100" color="blue" />
                    <div class="text-caption text-center q-mt-xs">{{ progress }}%</div>
                </div>

                <div class="loader" style="z-index: 11000;" v-if="loading && !uploading">
                    <q-spinner-gears size="50px" color="black" />
                </div>
                <q-banner v-if="success" class="app-banner app-banner--success" dense rounded>
                    Données enregistrées
                </q-banner>
                <q-banner v-if="errorBanner" class="app-banner app-banner--error" dense rounded>
                    Erreur durant l'enregistrement des données
                </q-banner>
                <div class="q-mt-md">
                    <q-btn label="Gérer les fichiers" color="warning" @click="resourcesList = true" />
                    <q-dialog v-model="resourcesList" maximized @hide="getResources">
                        <MediaManager :exhibitId="$store.state.exhibitId" />
                    </q-dialog>
                </div>
            </div>
            <div class="column flex-column" ref="resourceContainer" v-if="column2">
                <h4><q-icon name="preview" /> Pages intermédiaires</h4>
                <div>
                    <IntermediatePreview />
                </div>
            </div>
            <div class="column flex-column" v-if="column3">
                <h4><q-icon name="gps_fixed" /> Choisir un point d'accès</h4>
                <q-select label="Points" :options="points" option-label="name" emit-value map-options outlined
                    v-model="pointSelected" @update:model-value="handlePointSelection" dense />
                <span v-if="pointSelected"><q-icon name="feed" v-if="pointSelected.note" /> {{ pointSelected.note }}</span>
                <br v-if="pointSelected">

                <h4><q-icon name="note_add" /> Sélectionner les fichiers à associer à la page
                    intermédiaire</h4>
                <FileSelect v-if="pointSelected" label="Fichiers page intermédiaire" :options="resources" option-label="title"
                    option-value="resource_id" outlined v-model="resourcesFromPoints" emit-value map-options multiple
                    dense />
                <br>
                <q-btn label="Enregistrer" color="secondary" @click="saveAssociations" :disabled="!pointSelected" />
                <br>
                <h4><q-icon name="dashboard" /> Mettre en page</h4>
                <q-btn :disabled="!pointSelected" color="indigo" label="Mettre en page" @click="openPlace = true" />
                <div>
                    <h4><q-icon name="delete" /> Supprimer les assocations des fichiers de la page intermediaire</h4>
                    <q-list v-if="pointSelected" dense bordered padding class="rounded-borders">
                        <q-item v-for="element of resourcesBis" :key="element.id">

                            <q-item-section style="padding: 0px; border: none ;">
                                {{ element.title }}
                            </q-item-section>
                            <q-item-section
                                style="display: flex; flex-direction: row; justify-content: end; padding: 0px; border: none ;"
                                avatar>
                                <q-icon color="red" style="cursor: pointer;" name="delete"
                                    @click="deleteAssociation(element.resource_id)" />
                            </q-item-section>
                        </q-item>
                    </q-list>
                </div>
            </div>
        </div>
        <BetweenPageLoader v-if="betweenPage" />
    </div>
</template>
  
<script>
import { urlExposition } from '@/utils/urlExposition';
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import Header from '../components/Header.vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { useStore } from 'vuex';
import PointResourceAssociation from './PointResourceAssociation.vue';
import Intermediate from './Intermediate.vue';
import MediaManager from '../components/MediaManager.vue';
import IntermediatePreview from '../components/IntermediatePreview.vue';

import BetweenPageLoader from '../components/BetweenPageLoader.vue';
import FileSelect from '../components/FileSelect.vue';
import WorkflowBreadcrumb from '../components/WorkflowBreadcrumb.vue';
export default {
    name: 'ResourceManagement',
    components: {
        Header,
        PointResourceAssociation,
        Intermediate,
        IntermediatePreview,
        BetweenPageLoader,
        FileSelect,
        MediaManager,
        WorkflowBreadcrumb
    },
    setup() {
        var animationOptions = ref([
            { "title": "bounce", "titleFr": "rebondir" },
            { "title": "fadeIn", "titleFr": "apparaitre" },
            { "title": "flipInX", "titleFr": "pivoterEnX" },
            { "title": "lightSpeedIn", "titleFr": "vitesseLumiereEn" },
            { "title": "rotateIn", "titleFr": "tournerEn" },
            { "title": "slideInUp", "titleFr": "glisserDeBasEnHaut" },
            { "title": "zoomIn", "titleFr": "zoomEn" },
            { "title": "rollIn", "titleFr": "roulerEn" },
            { "title": "bounceOut", "titleFr": "rebondirDehors" },
            { "title": "fadeOut", "titleFr": "disparaitre" },
            { "title": "flipOutX", "titleFr": "pivoterHorsX" },
            { "title": "lightSpeedOut", "titleFr": "vitesseLumiereHors" },
            { "title": "rotateOut", "titleFr": "tournerHors" },
            { "title": "slideOutDown", "titleFr": "glisserDeHautEnBas" },
            { "title": "zoomOut", "titleFr": "zoomHors" },
            { "title": "rollOut", "titleFr": "roulerHors" }
        ])

        const store = useStore();
        const router = useRouter();
        const resourceContainer = ref(null);
        let loading = ref(false);
        let success = ref(false);
        let openAssociation = ref(false);
        let openPlace = ref(false);
        const exhibitIdBis = computed(() => store.state.exhibitId);
        let resourcesList = ref(false);
        const exhibitName = computed(() => store.state.exhibitName);
        let resources = ref([]);
        let resourcesBis = ref([]);
        let selectedResource = ref(null);
        let selectedAnimation = ref(null);
        let count = ref(0);
        let embedUrl = ref(urlExposition('template_6', 121))
        let betweenPage = ref(false)
        let mainResourceId = ref();
        let mainResource = ref();
        let points = ref();
        let resourcesFromPoints = ref([]);
        let resourcesFromPointsFull = ref([]);
        let pointSelected = ref();
        let resourcesFiltered = ref([])
        let errorBanner = ref(false);
        let uploading = ref(false);
        let progress = ref(0);
        let isDragging = ref(false);
        let selectedFiles = ref(null);
        let filesToUpload = ref([]);
        let uploadCurrent = ref(0);
        let uploadTotal = ref(0);
        let column1 = ref(true);
        let column2 = ref(true);
        let column3 = ref(true);
        const navigateBack = () => {
            router.go(-1);
        };

        const start = async () => {
            await getMainResource();
            await getPoints();
            await getResources();
        }

        const getFileIcon = (name) => {
            if (!name) return 'insert_drive_file';
            const ext = name.split('.').pop().toLowerCase();
            if (['jpg','jpeg','png','gif','svg','webp','bmp','tiff'].includes(ext)) return 'image';
            if (['mp4','avi','mov','wmv','webm','mkv'].includes(ext)) return 'videocam';
            if (['mp3','wav','ogg','flac','aac'].includes(ext)) return 'audiotrack';
            if (['doc','docx'].includes(ext)) return 'description';
            return 'insert_drive_file';
        };

        const addFiles = (files) => {
            const MAX_SIZE = 10000000;
            for (const file of files) {
                if (file.size > MAX_SIZE) {
                    alert(`"${file.name}" est volumineux, le chargement peut être long.`);
                }
                filesToUpload.value.push({
                    file,
                    title: file.name.replace(/\.[^/.]+$/, ''),
                    description: '',
                    source: '',
                    source_url: '',
                });
            }
        };

        const onDrop = (event) => {
            isDragging.value = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) addFiles(files);
        };

        const onFilesSelected = (files) => {
            if (files && files.length > 0) {
                addFiles(files);
                selectedFiles.value = null;
            }
        };

        const importFiles = async () => {
            if (filesToUpload.value.length === 0) return;
            try {
                uploading.value = true;
                loading.value = true;
                uploadTotal.value = filesToUpload.value.length;

                for (let i = 0; i < filesToUpload.value.length; i++) {
                    uploadCurrent.value = i + 1;
                    progress.value = 0;

                    const item = filesToUpload.value[i];
                    let formData = new FormData();
                    formData.append("file", item.file);
                    formData.append("name", item.file.name);
                    formData.append("title", item.title);
                    formData.append("description", item.description);
                    if (item.source) formData.append("source", item.source);
                    if (item.source_url) formData.append("source_url", item.source_url);
                    if (store.state.exhibitId) formData.append("exhibitId", store.state.exhibitId);
                    if (store.state.resourcesCount !== undefined) formData.append("index", store.state.resourcesCount);

                    let url = `${process.env.VUE_APP_BASEURL}/file`;
                    await axios.post(url, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                        onUploadProgress: (progressEvent) => {
                            if (progressEvent.lengthComputable) {
                                progress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            }
                        }
                    });
                }

                uploading.value = false;
                loading.value = false;
                filesToUpload.value = [];
                success.value = true;
                setTimeout(() => {
                    success.value = false;
                }, 1500);
                await getResources();
            } catch (error) {
                console.log(error);
                errorBanner.value = true;
                uploading.value = false;
                setTimeout(() => {
                    errorBanner.value = false;
                    loading.value = false;
                }, 1500);
            }
        };

        const MAX_RETRIES = 3;
        const RETRY_DELAY = 2000;
        const TIMEOUT_DELAY = 5000;

        const getMainResource = async (retries = MAX_RETRIES) => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/mainresource/${store.state.exhibitId}`;

                // Définition d'une promesse de timeout
                let timeoutPromise = new Promise((_, reject) => {
                    setTimeout(() => reject(new Error("Request timeout")), TIMEOUT_DELAY);
                });

                // Exécution de la requête Axios et de la promesse de timeout en parallèle
                let response = await Promise.race([
                    axios.get(url),
                    timeoutPromise
                ]);

                // Récupération de l'id de la page principale
                mainResourceId.value = response.data[0].main_resource_id;

            } catch (error) {
                console.error("Erreur lors de la récupération de la ressource principale :", error.message);

                if (retries > 0) {
                    console.log(`Nouvelle tentative dans ${RETRY_DELAY / 1000} secondes. Tentatives restantes : ${retries}`);
                    setTimeout(() => getMainResource(retries - 1), RETRY_DELAY);
                } else {
                    console.error("Toutes les tentatives de récupération de la ressource principale ont échoué.");
                }
            }
        };

        const getPoints = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/pointsFromMainResource/${mainResourceId.value}`;
                let response = await axios.get(url);
                var outputJSON = {};
                response.data.forEach(function (item) {
                    if (
                        !Object.prototype.hasOwnProperty.call(outputJSON, item.point_id)
                    ) {
                        outputJSON[item.point_id] = [];
                    }

                    outputJSON[item.point_id].push(item);
                });
                resourcesFromPoints.value = outputJSON;
                resourcesFromPointsFull.value = outputJSON;
                store.commit("SET_RESOURCESFROMPOINTS", resourcesFromPoints)
                var uniqueData = [];
                for (let item of Object.values(resourcesFromPoints.value)) {
                    if (item[0].point_id && item[0].name) {
                        let exists = uniqueData.find(
                            (dataItem) => dataItem.point_id === item.point_id
                        );
                        if (!exists) {
                            uniqueData.push({
                                point_id: item[0].point_id,
                                name: item[0].name,
                                note: item[0].note,
                            });
                        }
                    }
                }

                points.value = uniqueData;
                points.value = points.value.sort((a, b) => {
                    const titleA = a.title ? a.title.toUpperCase() : "";
                    const titleB = b.title ? b.title.toUpperCase() : "";
                    if (titleA < titleB) return -1;
                    if (titleA > titleB) return 1;
                    return 0;
                });

            } catch (error) {
                console.log(error);
            }
        };

        const handlePointSelection = async () => {
            try {
                store.commit("SET_POINTSELECTED", pointSelected.value);
                await getResourcesFromPoints();

            } catch (error) {
                console.log(error);
            }
        }

        const openNewTab = () => {
            window.open(store.getters.exhibitUrl, '_blank');
        }

        const navigateToExpo_bu = () => {
            router.push({ path: `/expo/${store.state.exhibitId}` });
        }

        const navigateToCreation = () => {
            router.push({ path: `/creation` });
        }

        const navigateToAddPoint = () => {
            router.push({ path: `/point` });
        }

        const navigateToExhibits = () => {
            router.push("/admin");
        }

        const deleteAssociation = async (resourceId) => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/pointresourceAssociation/${resourceId}`;
                await axios.delete(url);
                success.value = true;
                setTimeout(async () => {
                    await handlePointSelection();
                    success.value = false;
                }, 1500);
            } catch (error) {
                console.log(error)
                errorBanner.value = true;
                setTimeout(() => {
                    errorBanner.value = false;
                    loading.value = false;
                }, 1500);
            }
        }

        const closeIntermediate = async () => {
            console.log("[closeIntermediate] Début de la fermeture de l'interface intermédiaire");
            
            // Fermeture de l'interface
            openPlace.value = false;
            console.log("[closeIntermediate] Interface fermée (openPlace.value = false)");
            
            // Sauvegarde du point sélectionné
            const pointSelectedTemp = pointSelected.value;
            console.log("[closeIntermediate] Point sélectionné sauvegardé:", pointSelectedTemp);
            
            // Simuler un changement de point puis retour au point de base
            if (pointSelectedTemp && pointSelectedTemp.point_id) {
                console.log("[closeIntermediate] Simulation d'un changement de point");
                
                // Étape 1: Sélectionner null pour forcer le changement
                pointSelected.value = null;
                store.commit("SET_POINTSELECTED", null);
                console.log("[closeIntermediate] Point désélectionné temporairement");
                
                // Attendre un court délai
                setTimeout(() => {
                    console.log("[closeIntermediate] Resélection du point original:", pointSelectedTemp.point_id);
                    
                    // Étape 2: Resélectionner le point original
                    pointSelected.value = pointSelectedTemp;
                    store.commit("SET_POINTSELECTED", pointSelectedTemp);
                    
                    // Étape 3: Déclencher handlePointSelection pour recharger les ressources
                    nextTick(async () => {
                        await handlePointSelection();
                        console.log("[closeIntermediate] Point resélectionné et ressources rechargées avec succès");
                    });
                }, 100); // Délai de 100ms entre la désélection et la resélection
            } else {
                console.log("[closeIntermediate] Aucun point à resélectionner (pointSelectedTemp invalide)");
            }
            
            console.log("[closeIntermediate] Processus de fermeture terminé");
        }
 
        onMounted(() => {
            start();
        });

        // Watcher pour détecter la fermeture du popup de mise en page
        watch(openPlace, async (newValue, oldValue) => {
            // Si le popup se ferme (passe de true à false) et qu'un point est sélectionné
            if (oldValue === true && newValue === false && pointSelected.value) {
                // Fermer la colonne 2 (preview)
                column2.value = false;
                // Attendre un court délai puis rouvrir
                setTimeout(() => {
                    column2.value = true;
                }, 100);
                await handlePointSelection();
            }
        });

        const getResources = async () => {
            try {
                let url = `${process.env.VUE_APP_BASEURL}/resources/${store.state.exhibitId}`;
                let response = await axios.get(url);
                resources.value = response.data;
                resources.value = resources.value.sort((a, b) => {
                    const titleA = a.title ? a.title.toUpperCase() : "";
                    const titleB = b.title ? b.title.toUpperCase() : "";
                    if (titleA < titleB) return -1;
                    if (titleA > titleB) return 1;
                    return 0;
                });
                resourcesBis.value = response.data;
                resourcesBis.value = resourcesBis.value.sort((a, b) => {
                    const titleA = a.title ? a.title.toUpperCase() : "";
                    const titleB = b.title ? b.title.toUpperCase() : "";
                    if (titleA < titleB) return -1;
                    if (titleA > titleB) return 1;
                    return 0;
                });
            } catch (error) {
                console.log(error)
            }
        }



        const getResourcesFromPoints = async () => {
            try {
                if (!pointSelected.value || !pointSelected.value.point_id) {
                    console.warn('Aucun point sélectionné ou point_id manquant');
                    return;
                }
                let url = `${process.env.VUE_APP_BASEURL}/resourcesFromPointWithAssociations/${pointSelected.value.point_id}`;
                let response = await axios.get(url);
                let extractedIds = [];
                for (let item of response.data) {
                    extractedIds.push(item.resource_id);
                }
                resourcesFromPoints.value = extractedIds;
                resourcesBis.value = resources.value;
                resourcesBis.value = resourcesBis.value.filter(resource => resourcesFromPoints.value.includes(resource.resource_id))
            } catch (error) {
                console.log(error);
            }
        }

        const saveAll = async () => {
            await saveAssociations();
        }


        const navigateToAssociation = () => {
            betweenPage.value = true;
            saveAll()
            setTimeout(() => {
                router.push({ path: `/associationManagement` });
            }, 3000)

        }

        const saveAssociations = async () => {
            try {
                if (!pointSelected.value || !pointSelected.value.point_id) {
                    console.warn('Aucun point sélectionné ou point_id manquant');
                    return;
                }
                let url = `${process.env.VUE_APP_BASEURL}/pointresourceassociation/${pointSelected.value.point_id}`;
                let postBody = resourcesFromPoints.value;
                await axios.post(url, postBody);
                success.value = true;
                setTimeout(async () => {
                    success.value = false;
                    await getResources();
                    await handlePointSelection();
                }, 1500);
            } catch (error) {
                console.log(error);
                errorBanner.value = true;
                setTimeout(() => {
                    errorBanner.value = false;
                }, 1500);
            }
        }

        return {
            resourceContainer,
            loading,
            success,
            openAssociation,
            openPlace,
            embedUrl,
            exhibitIdBis,
            resourcesList,
            exhibitName,
            resources,
            selectedResource,
            animationOptions,
            selectedAnimation,
            count,
            betweenPage,
            mainResourceId,
            mainResource,
            points,
            pointSelected,
            resourcesFromPoints,
            resourcesFiltered,
            errorBanner,
            resourcesFromPointsFull,
            resourcesBis,
            uploading,
            progress,
            isDragging,
            selectedFiles,
            filesToUpload,
            uploadCurrent,
            uploadTotal,
            navigateBack,
            onDrop,
            onFilesSelected,
            importFiles,
            getFileIcon,
            openNewTab,
            navigateToExpo_bu,
            navigateToCreation,
            navigateToAddPoint,
            getResources,
            navigateToAssociation,
            saveAll,
            navigateToExhibits,
            handlePointSelection,
            saveAssociations,
            deleteAssociation,
            column1,
            column2,
            column3,
            closeIntermediate

        };
    },
};
</script>
  
<style scoped>
.container {
    display: flex;
    justify-content: center;
}

.column {
    flex: 1;
    margin: 10px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
}

.column h4 {
    font-size: 20px;
    font-weight: 600;
}

.navButtons {
    display: flex;
    justify-content: space-between;
}

.banner {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;

    /* Design */
    padding: 15px 30px;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    /* Typographie */
    font-size: 16px;
    font-family: 'Helvetica', sans-serif;
    /* Remplacez par la police de votre choix */

    /* Transition */
    transition: all 0.3s ease-in-out;
}


.infos {
    font-size: 16px;
    border: 1px solid gray;
    width: 90%;
    margin: auto;
    margin-bottom: 5px;
    border-radius: 5px;
}

.title {
    display: flex;
    align-items: center;
    font-size: 1.2 rem;
    margin-left: 1%;
}

.loader {
    position: fixed;
    /* ou "absolute" selon le besoin */
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-color: rgba(255, 255, 255, 0.8);
    /* Un fond blanc semi-transparent */
}

.fixed-layout {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    /* espace entre les éléments */
}

.flex-column {
    max-width: 600px;
    /* Ajoutez éventuellement une marge si vous voulez espacer les colonnes */
    margin: 0 10px;
}

.column-toggle-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.drop-zone {
  border: 2px dashed #bdbdbd;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  transition: border-color 0.2s, background-color 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.drop-zone--active {
  border-color: #1976d2;
  background-color: rgba(25, 118, 210, 0.06);
}
</style>
  